import React from 'react';

const StatItem = ({ number, label }) => (
    <div className="text-center">
        <p className="text-5xl md:text-6xl font-bold text-white mb-2">{number}</p>
        <p className="text-sm md:text-base uppercase tracking-wider text-white/90">{label}</p>
    </div>
);

const Stats = () => {
    const stats = [
        { number: "25+", label: "Happy Clients" },
        { number: "12+", label: "Years of Experience" },
        { number: "15+", label: "Skilled People" }
    ];

    return (
        <section className="relative py-16 overflow-hidden">
            {/* Background with gradient and wave effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#008080] via-[#009999] to-[#008080]"></div>

            {/* Decorative wave overlay */}
            <div className="absolute inset-0 opacity-10">
                <svg className="absolute bottom-0 w-full" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" fill="currentColor" className="text-white" />
                </svg>
            </div>

            <div className="container mx-auto px-4 relative z-10">
                <div className="grid grid-cols-3 gap-8 md:gap-16 max-w-4xl mx-auto">
                    {stats.map((stat, index) => (
                        <StatItem key={index} {...stat} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Stats;
